module.exports = __webpack_public_path__ + "static/tactics_collection_florball-b5329b0449f751a0ca105b76735a30e1.mp4";